import { Button } from "@screener/uikit/components/button";
import { Separator } from "@screener/uikit/components/separator";
import { Tooltip, TooltipContent, TooltipTrigger } from "@screener/uikit/components/tooltip";
import googleIcon from "@/assets/google.svg";

/** Подсказка неактивной кнопки (spec `web-login`, «Google»). */
export const GOOGLE_HINT = "Скоро";

/**
 * Разделитель «или» и неактивная кнопка «Продолжить с Google»
 * (stage9-auth-redesign, Д6). Обработчика нет: вход через Google в ТЗ не
 * спроектирован, кнопка лишь занимает место по макету. У неактивной кнопки
 * `pointer-events: none`, поэтому подсказка `Tooltip` висит на обёртке.
 */
export function GoogleAlternative() {
  return (
    <>
      <div className="flex items-center gap-2.5">
        <Separator className="flex-1" />
        <span className="text-[11px] font-medium tracking-[0.06em] text-muted-foreground uppercase">
          или
        </span>
        <Separator className="flex-1" />
      </div>
      <Tooltip>
        <TooltipTrigger render={<span className="block" />}>
          <Button type="button" variant="outline" size="lg" disabled className="w-full gap-1.5">
            <img src={googleIcon} alt="" className="size-4" />
            Продолжить с Google
            <span className="sr-only">{GOOGLE_HINT.toLowerCase()}</span>
          </Button>
        </TooltipTrigger>
        <TooltipContent>{GOOGLE_HINT}</TooltipContent>
      </Tooltip>
    </>
  );
}
